module.exports = __webpack_public_path__ + "static/media/TheHiddenDragon.c3932d5c.jpg";